import { Link } from 'react-router-dom';
import { formatThousands } from '../../../utils/format/formatThousands';
import { pluralize } from '../../../utils/pluralize';
import { IconStarFilled } from '../../icon/IconStarFilled';
import { Flex } from '../../layout/Flex';
import { NumberTypography } from '../../price/styles';
import { Typography } from '../../typography/Typography';
import { ReviewsInfoProps } from './types';

export const ReviewsInfo = ({ rating, reviews, url, onClick, ...other }: ReviewsInfoProps) => {
    if (!rating && !reviews) {
        return null;
    }

    const linkProps = url ? { as: Link, to: url, target: '_blank' } : {};
    const ratingValue = rating ? rating.toFixed(1).replace('.', ',') : undefined;
    const reviewsValue = reviews
        ? `・${formatThousands(reviews)} ${pluralize(reviews, 'отзыв', 'отзыва', 'отзывов')}`
        : undefined;

    return (
        <Flex
            {...linkProps}
            {...other}
            onClick={onClick}
            direction="row"
            textDecoration="none"
            alignItems="center"
        >
            {ratingValue ? (
                <Flex direction="row" spacing={0.5} alignItems="center">
                    <IconStarFilled color="var(--always-yellow)" />
                    <NumberTypography variant="caption" weight="medium">
                        {ratingValue}
                    </NumberTypography>
                </Flex>
            ) : null}
            {reviewsValue ? (
                <Typography variant="caption" color="secondary">
                    {reviewsValue}
                </Typography>
            ) : null}
        </Flex>
    );
};
